import React, { useState } from "react";

import { findElementByValue } from "utils";

import RuleModal from "../../SimplifiedBuilder/Components/ExtraSettings/RulesTab/RuleModal";
import { useRules } from "../../useRules";
import { findInDomFieldValueByLabel, getRuleTypeByModalTitle } from "./utils";


export const SimpleExpressionModal = props => {
	const { getFormDefinition } = props;

	const previousObserver = React.useRef(null);

	const [ ruleType, setRuleType ] = useState(null);
	const [ rulesState, setRulesState ] = useState({
		completeFormModel: {},
		parentQuestionConfig: {},
	});

	const onChangeRule = ruleObject => {
		const nativeExpressionField = document.querySelector("div.eo-vis-control-runtime-panel--textExpression textarea");
		nativeExpressionField.value = ruleObject[ruleType];
		nativeExpressionField.dispatchEvent(new Event("change", { bubbles: true }));
	};

	const {
		showRuleSelector,
		ruleModalProps,
		setShowRuleSelector,
		addRuleToGroup,
		resetGroups,
	} = useRules({
		ruleType,
		onChange: onChangeRule,
		completeFormModel: rulesState.completeFormModel,
		parentQuestionConfig: rulesState.parentQuestionConfig,
	});

	const updateRulesDependencies = async (node, fieldValue) => {
		resetGroups();

		const ruleType = getRuleTypeByModalTitle(node);
		setRuleType(ruleType);

		const formDefinition = await getFormDefinition();
		const currentFormElement = findElementByValue(formDefinition, fieldValue);

		// we need to reset current rule to prevent concatenation of rules when adding a new rule using simple expression modal
		currentFormElement[ruleType] = undefined;

		setRulesState({
			completeFormModel: formDefinition.rows[0].cols[0],
			parentQuestionConfig: currentFormElement,
		});
	};

	const changeTextInModal = modalElement => {
		for (const textNode of modalElement.querySelectorAll("p")) {
			if (textNode.textContent.includes("Define a condition expression")) {
				textNode.textContent = "Define a condition expression using the condition builder, create simple expression" +
					" functionality or by directly giving the expression text.";
				break;
			}
		}

		modalElement.querySelector("div.eo-vis-control-textarea-tip.ng-binding.ng-scope").textContent = "💡Note: You can" +
			" start defining an expression with the condition builder or create simple expression functionality and then edit the generated expression.";
	};

	const appendOpenModalButton = element => {
		const btn = document.createElement("button");
		btn.className = "btn btn-primary";
		btn.innerText = "Create Simple Expression";
		btn.onclick = () => setShowRuleSelector(true);

		element.querySelector("div.pull-right").appendChild(btn);
	};

	React.useEffect(() => {
		if (previousObserver.current) {
			previousObserver.current.disconnect();
			previousObserver.current = null;
		}

		const callback = mutations => {
			// eslint-disable-next-line no-label-var
			findLoop: for (let mutation of mutations) {
				for (let node of mutation.addedNodes) {
					if (!(node instanceof HTMLElement)) {continue;}
					if (node.matches("div.eo-vis-control-runtime-panel--condition")) {
						const fieldValue = findInDomFieldValueByLabel("Value");
						if (Boolean(fieldValue)) {
							appendOpenModalButton(node);
							changeTextInModal(mutation.target);
							updateRulesDependencies(mutation.target, fieldValue);
						}
						break findLoop;
					}
				}
			}
		};

		const observer = new MutationObserver(callback);
		observer.observe(
			document.body,
			{
				childList: true,
				subtree: true,
			},
		);
		previousObserver.current = observer;

		return () => {
			if (previousObserver.current) {
				previousObserver.current.disconnect();
				previousObserver.current = null;
			}
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	if (!showRuleSelector) {return null;}

	return (
		<RuleModal
			{...ruleModalProps}
			open
			onClose={() => {
				setShowRuleSelector(false);
			}}
			onAddRule={addRuleToGroup}
			ruleType={ruleType}
		/>
	);
};
